import api from './api';
import { ApiResponse, PaginatedResponse, Dress } from '../types';

export interface DressLike {
  id: string;
  likedAt: string;
  displayOrder: number;
  dress: Dress;
}

export interface LikeCheckResponse {
  likedDressIds: string[];
}

export interface LikeStatsResponse {
  topLikedDresses: {
    dressId: string;
    dressName: string;
    designer: string;
    tier: string;
    likeCount: number;
  }[];
  totalUniqueCustomers: number;
}

class DressLikesService {
  async likeDress(dressId: string): Promise<void> {
    await api.post(`/dress-likes/${dressId}`);
  }

  async unlikeDress(dressId: string): Promise<void> {
    await api.delete(`/dress-likes/${dressId}`);
  }

  async getLikedDresses(page: number = 1, limit: number = 20): Promise<PaginatedResponse<DressLike>> {
    const response = await api.get<PaginatedResponse<DressLike>>('/dress-likes', {
      page,
      limit
    });
    return response.data;
  }

  async checkLikes(dressIds: string[]): Promise<string[]> {
    const response = await api.post<ApiResponse<LikeCheckResponse>>('/dress-likes/check', {
      dressIds
    });
    return response.data.data.likedDressIds;
  }

  async reorderLikes(orderedLikeIds: string[]): Promise<void> {
    await api.put('/dress-likes/reorder', {
      orderedLikeIds
    });
  }

  async getLikeStats(params?: {
    startDate?: string;
    endDate?: string;
    limit?: number;
  }): Promise<LikeStatsResponse> {
    const response = await api.get<ApiResponse<LikeStatsResponse>>('/dress-likes/stats', params);
    return response.data.data;
  }
}

export default new DressLikesService();